































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import ErrorMessages from '@/components/ErrorMessages.vue'
import Addresses from './Addresses.vue'
import Modal from '@/components/Modal.vue'
import { PaymentsModule } from '@/store/modules/payments.module'
import { EPaymentReceiptType } from '@zunta/configurations'

import { IReceiptContact } from '@/interfaces'
import { openFile } from '@/utils/helpers'
import { STORAGE_URL } from '@/constants'

@Component({
  props: {
    paymentId: {
      type: [String, Number],
      required: true
    },
    isMobile: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    Addresses,
    Modal,
    ErrorMessages
  }
})
export default class AddressesPopup extends Vue {
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store);

  isSending: boolean = false;
  errors: string[] = [];
  receiptContact: IReceiptContact | null = null;

  get successButton () {
    return this.receiptContact && this.receiptContact.receiptType === EPaymentReceiptType.PRINT_RECEIPT ? 'Print' : 'Send'
  }

  setContact (contact: IReceiptContact) {
    this.receiptContact = contact
  }

  validate () {
    this.errors = []
    if (!this.receiptContact || !this.receiptContact.receiptAddress) {
      this.errors.push('Choose Contact')
    }
    return this.errors.length === 0
  }

  async send () {
    if (!this.validate()) {
      return
    }

    this.isSending = true
    let response
    const contact: IReceiptContact = this.receiptContact as IReceiptContact
    if (EPaymentReceiptType.EMAIL === contact.receiptType) {
      response = await this.paymentsModuleInstance.sendPaymentReceiptViaEmail({
        paymentId: this.$props.paymentId,
        contact: {
          name: contact.receiptName,
          email: contact.receiptAddress
        }
      })
    } else if (EPaymentReceiptType.ADDRESS === contact.receiptType) {
      response = await this.paymentsModuleInstance.sendPaymentReceiptViaMail({
        paymentId: this.$props.paymentId,
        contact: {
          name: contact.receiptName,
          address: contact.receiptAddress,
          addressLine1: contact.addressLine1 as string,
          addressLine2: contact.addressLine2 as string,
          state: contact.state as string,
          city: contact.city as string,
          zip: contact.zip as string
        }
      })
    } else if (EPaymentReceiptType.PRINT_RECEIPT === contact.receiptType) {
      const pdf = await this.paymentsModuleInstance.generateReceipt(this.$props.paymentId)
      openFile(`${STORAGE_URL}?file=${pdf}`)
      this.isSending = false
      this.$emit('close')
      return
    }
    this.isSending = false
    if (response === 'OK') {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-success-color)',
        header: 'Send Receipt',
        message: 'Receipt Successfully Sent',
        icon: 'check'
      })
      this.$emit('close')
    } else if (typeof response !== 'undefined') {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        header: 'Send Receipt',
        message: 'Something went wrong',
        icon: 'warning'
      })
    }
    this.$emit('close')
  }
}
